import axios, { AxiosRequestConfig } from 'axios';
import { StripePaymentMethodDTO } from '../types/StripePaymentMethodDTO';
import { DataResponse } from '../types/api';

const URL = '/v2/stripe-payment-methods';
const PAYMENT_INTENT_URL = '/create-payment-intent';
const DEFAULT_PAYMENT_METHOD_URL = '/default-payment-method';

class StripePaymentServices {
  static createPaymentIntent(
    data: StripePaymentMethodDTO,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<StripePaymentMethodDTO>> {
    return axios.post(URL+PAYMENT_INTENT_URL, data, config);
  }

  static updateCustomerDefaultPaymentMethod(
    data: StripePaymentMethodDTO,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<StripePaymentMethodDTO>> {
    return axios.post(URL+DEFAULT_PAYMENT_METHOD_URL, data, config);
  }
}

export { StripePaymentServices };
